import React from 'react';

function Footer() {
  return (
    <footer className="tc-footer-style1">
      <div className="container">

        {/* ── Top Section ── */}
        <div className="top-content section-padding">
          <div className="row gx-0">

            {/* Col 1 – Logo + tagline + social */}
            <div className="col-lg-4">
              <div className="info-side">
                {/* Logo */}
                <div className="logo mb-30">
                  <a href="#">
                    <img src="/home1/assets/img/logo.png" alt="SS" />
                  </a>
                </div>

                <div className="text fsz-15 color-333 lh-3 fw-400 mt-20">
                  We believe that architecture has the power to shape lives and
                  uplift communities. Archin&rsquo;s philosophy is a passion for
                  innovation, sustainability and timeless aesthetics.
                </div>

                {/* Social links */}
                <div className="foot-social mt-40">
  {/* Facebook */}
  <a
    href="https://www.facebook.com/share/1CxX2Vsq7p/"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Facebook"
  >
    <i className="fab fa-facebook-f"></i>
  </a>

  {/* Instagram */}
  <a
    href="https://www.instagram.com/ss.architects.interiors?igsh=eDNzNndzejR2ZjNj"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Instagram"
  >
    <i className="fab fa-instagram"></i>
  </a>

  {/* Threads */}
  <a
    href="https://www.threads.com/@ss.architects.interiors"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Threads"
  >
    <i className="fa-brands fa-threads"></i>
  </a>

  {/* LinkedIn */}
  <a
    href="https://www.linkedin.com/company/ss-architects-interiors/"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="LinkedIn"
  >
    <i className="fab fa-linkedin-in"></i>
  </a>
</div>
              </div>
            </div>

            {/* Col 2 – Navigation menus */}
            <div className="col-lg-2 offset-lg-1">
              <div className="branch-card">
                <h6 className="mb-20 mt-5 mt-lg-0 fw-600 text-uppercase ls-2 fsz-12">
                  Navigation
                </h6>
                <ul className="footer-links">
                  <li><a href="#">Home</a></li>
                  <li><a href="#">Studio</a></li>
                  <li><a href="#">Cases</a></li>
                  <li><a href="#">News</a></li>
                  <li><a href="#">Contact</a></li>
                </ul>
              </div>
            </div>

            {/* Col 3 – Services */}
            <div className="col-lg-2">
              <div className="branch-card">
                <h6 className="mb-20 mt-5 mt-lg-0 fw-600 text-uppercase ls-2 fsz-12">
                  Services
                </h6>
                <ul className="footer-links">
                  <li><a href="#">3D Visualization</a></li>
                  <li><a href="#">Interior Architecture</a></li>
                  <li><a href="#">Sustainable Design</a></li>
                  <li><a href="#">Urban Planning</a></li>
                  <li><a href="#">Landscape Design</a></li>
                </ul>
              </div>
            </div>

            {/* Col 4 – Offices + Newsletter */}
            <div className="col-lg-3">

              {/* Boston office */}
              <div className="branch-card">
                <h6 className="mb-20 mt-5 mt-lg-0 fw-600 text-uppercase ls-2 fsz-12">
                  Boston, MA
                </h6>
                <ul className="footer-links">
                  <li><a href="#">Room 505, 49 Brimmer St, Boston, MA 02108</a></li>
                  <li><a href="mailto:contact@archinstudio.co">contact@archinstudio.co</a></li>
                  <li><a href="tel:+10543256787">(054) 325-6787</a></li>
                </ul>
              </div>

              {/* Portland office */}
              <div className="branch-card mt-30">
                <h6 className="mb-20 fw-600 text-uppercase ls-2 fsz-12">
                  Portland, OR
                </h6>
                <ul className="footer-links">
                  <li><a href="#">2221 SW Broadway Dr, Portland, OR 97201</a></li>
                  <li><a href="mailto:contact@archinstudio.co">contact@archinstudio.co</a></li>
                  <li><a href="tel:+10214246368">(021) 424-6368</a></li>
                </ul>
              </div>

              {/* Newsletter */}
              <div className="branch-card mt-30">
                <h6 className="mb-15 fw-600 text-uppercase ls-2 fsz-12">
                  Newsletter
                </h6>
                <p className="fsz-13 color-666 mb-15">
                  Stay updated with our latest projects &amp; insights.
                </p>
                <div className="foot-newsletter d-flex gap-0">
                  <input
                    type="email"
                    placeholder="Your email"
                    className="form-control rounded-0 border-0 border-bottom fsz-13"
                  />
                  <button className="butn border rounded-pill px-20 py-10 hover-bg-white ms-10 flex-shrink-0">
                    <span className="fsz-12">
                      Subscribe <i className="small ms-1 ti-arrow-top-right"></i>
                    </span>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* ── Bottom Bar ── */}
        <div className="foot">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <p className="fsz-13 color-666 mb-0">
                © {new Date().getFullYear()} Archin Studio. All Rights Reserved.
              </p>
            </div>
            <div className="col-lg-6">
              <div className="foot-links mt-4 mt-lg-0 d-flex gap-30 justify-content-lg-end flex-wrap">
                <a href="#" className="fsz-13">Terms &amp; Conditions</a>
                <a href="#" className="fsz-13">Privacy Policy</a>
                <a href="#" className="fsz-13">Partner Policy</a>
                <a href="#" className="fsz-13">Sitemap</a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;